// import logo from './logo.svg';
// import './App.css';
// import MainScreen from './Screen/MainScreen/MainScreen';

// function App() {

//   return (
//     <>
//     {/* <div className='bg-slate-600 text-cyan-500'>hello</div> */}
//       <MainScreen/>
//     </>
//   );
// }

// export default App;




import React from 'react';
import { Helmet } from 'react-helmet';
import './App.css';
import MainScreen from './Screen/MainScreen/MainScreen';
import logo from '../src/Vinesh_logo.png'
function App() {
  const websiteTitle = 'Vinesh';
  const websiteDescription = 'Leading Digital Textile Printing';
  const websiteURL = 'https://vineshprints.com';
  // const websiteImageURL = '';

  return (
    <>
      {/* Add the react-helmet component */}
      <Helmet>
        <title>{websiteTitle}</title>
        <meta property="og:title" content={websiteTitle} />
        <meta property="og:description" content={websiteDescription} />
        <meta property="og:image" content={logo} />
        <meta property="og:url" content={websiteURL} />
      </Helmet>
      {/* Your website content */}
      <MainScreen/>
    </>
  );
}

export default App;
